import { Route, Router, useLocation } from "wouter";
import AdminApp from "./admin/AdminApp";
import "./App.css";
import UserApp from "./user/UserApp";
import { ConfigProvider } from "antd";
import { memo, useEffect } from "react";
import {
  startVersionCheck,
  refreshPage,
  storeVersion,
} from "./utilities/versionChecker";

function App() {
  const [location] = useLocation();
  const isAdmin = location.startsWith("/admin");

  useEffect(() => {
    // Start checking for new versions every 5 minutes
    // Silently refresh the page when a new version is detected
    const stopCheck = startVersionCheck((newVersion, oldVersion) => {
      console.log(
        `New version detected: ${oldVersion} → ${newVersion}. Refreshing...`
      );
      refreshPage();
    });

    // Store the current version
    const storeCurrentVersion = async () => {
      const currentVersion = await (
        await fetch(`${window.location.origin}/version.json?t=${Date.now()}`, {
          cache: "no-store",
          headers: { "Cache-Control": "no-cache" },
        })
      ).json();
      storeVersion(currentVersion.version);
    };
    storeCurrentVersion();

    // Cleanup on unmount
    return () => stopCheck();
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "rgb(4, 116, 184)",
          borderRadius: 2,
          // colorBgContainer: "#f6ffed",
        },
      }}
    >
      <div className="App">
        <Router>
          {isAdmin ? (
            <>
              <Route path="/admin" component={AdminApp} />
              <Route path="/admin/*" component={AdminApp} />
            </>
          ) : (
            <Route path="/*" component={UserApp} />
          )}
        </Router>
      </div>
    </ConfigProvider>
  );
}

export default memo(App);
